import { useQuery } from "@tanstack/react-query";
import { getUserFollowers, getUserFollowing, getUserNetwork } from "./services/network.service";

export const useUserFollowers = (userId?: string, params?: string) => {
  return useQuery({
    queryKey: ["userFollowers", userId, params],
    queryFn: () => getUserFollowers(userId!, params),
    enabled: !!userId,
  });
};

export const useUserFollowing = (userId?: string, params?: string) => {
  return useQuery({
    queryKey: ["userFollowing", userId, params],
    queryFn: () => getUserFollowing(userId!, params),
    enabled: !!userId,
  });
};

export const useUserNetwork = (userId?: string, params?: string) => {
  return useQuery({
    queryKey: ["userNetwork", userId, params],
    queryFn: () => getUserNetwork(userId!, params),
    enabled: !!userId,
  });
};
